import { Record } from 'immutable';

export const Contact = new Record({
    success: false,
    message: null,
    isPending: false,
    data: null
});